<script setup lang="ts">
import { ArrowsRightLeftIcon } from '@heroicons/vue/24/outline'
import { useSwitchLeave } from '~/query/user-switch/user-switch.mutation'
const { t } = useI18n()

const { mutate } = useSwitchLeave()

const disconnectHandler = () => {
  if (!useAuth().isImpersonateUser.value) {
    if (confirm(t('component.header.confirm_disconnect'))) {
      useLogout()
    }
  } else {
    mutate()
  }
}

const sidebarOpen = ref<boolean>(false)
const sidebarOpenForDesktop = ref<boolean>(true)
</script>

<template>
  <div>
    <SideBar v-model:sidebar-open="sidebarOpen" v-model:sidebar-open-for-desktop="sidebarOpenForDesktop" />
    <div :class="sidebarOpenForDesktop ? 'xl:ml-64' : ''">
      <Header v-model:sidebar-open="sidebarOpen" v-model:sidebar-open-for-desktop="sidebarOpenForDesktop" />
      <div class="bg-zinc-100 content">
        <slot />
      </div>
    </div>
    <div v-if="$auth.isImpersonateUser.value" class="flex items-center sticky bottom-0 z-30 gap-x-2 bg-red-500 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
      <p class="text-sm leading-6 text-white">
        Vous êtes connecté en tant que <span class="font-bold">{{ $auth.session.value?.username ?? $auth.session.value?.email }}</span>
      </p>
      <div class="flex flex-1">
        <button type="button" class="inline-flex items-center rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" @click="disconnectHandler">
          <ArrowsRightLeftIcon class="-ml-0.5 mr-0.5 h-4 w-4" aria-hidden="true" />
          Revenir à mon compte
        </button>
      </div>
    </div>
  </div>
</template>
